import React from 'react';
import PropTypes from 'prop-types';


function Input({ label, name, type, value, onChange }) {
    return (
        <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            <input
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-blue focus:border-primary-blue sm:text-sm"
            />
        </div>
    );
}

Input.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
};

Input.defaultProps = {
    label: 'Email',
    name: 'email',
    type: 'text',
    placeholder: 'Enter your email',
    value: '',
};

export default Input;
